"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _path = _interopRequireDefault(require("../../helpers/path"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _APIcon = _interopRequireDefault(require("../common/APIcon"));
require("../../styles/components/common/StandaloneForm.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ModalBodyComponent = function ModalBodyComponent(props) {
  var onClose = props.onClose;
  var childProps = props.componentProps || {};
  var baseClasses = (0, _cssClassesHelper.getBEMClasses)('standalone-form', props.customClass);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('container')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('header')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('header-text')
  }, props.headerText), !props.hideClose && /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    onClick: onClose,
    to: (0, _path["default"])('/'),
    className: baseClasses('close-icon')
  }, /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
    name: "close",
    classModifiers: "big"
  }))), props.component && /*#__PURE__*/_react["default"].createElement(props.component, childProps));
};
ModalBodyComponent.propTypes = {
  headerText: _propTypes["default"].string,
  onClose: _propTypes["default"].func
};
ModalBodyComponent.defaultProps = {
  onClose: function onClose() {}
};
var _default = exports["default"] = ModalBodyComponent;